import type { NodeViewProps } from "@tiptap/react";
import { parseDirectiveRaw } from "../directives/core/parseRaw";
import { printTableDirectiveStrategy } from "../directives/core/chipStrategy";
import { VariableTokenNodeViewSimple } from "./variableTokenNodeViewSimple";
import { VariableTokenNodeViewDirective } from "./directiveChip/variableTokenNodeViewDirective";

export const VariableTokenNodeView = (props: NodeViewProps) => {
  let raw = props.node.attrs.raw as string;
  if (/^\{\{.*\}\}$/.test(raw)) raw = raw.slice(2, -2);
  const parsed = parseDirectiveRaw(raw);
  if (parsed === null) {
    return <VariableTokenNodeViewSimple {...props} />;
  }
  const strategy =
    parsed.directive === "print(table)" ? printTableDirectiveStrategy : null;
  return <VariableTokenNodeViewDirective strategy={strategy} {...props} />;
};
